import React from 'react';
import { StyleSheet, View } from 'react-native';

import { useColors } from '../../../../../../hooks';
import useDevice from '../../../../../../hooks/use-device';
import TranslatableText2 from '../../../../../translatable-text2';

interface SpeechBalloonProps {
  line: string;
  lineTranslation?: string;
  isRightSide?: boolean;
  fontSize?: number;
}

export default function SpeechBalloon({
  line,
  lineTranslation,
  isRightSide,
  fontSize = 16,
}: SpeechBalloonProps) {
  const noBorder = 0;
  const colors = useColors();
  const { isMobile } = useDevice();

  return (
    <View
      style={[
        styles.balloon,
        isMobile && styles.fullWidth,
        isRightSide
          ? {
              backgroundColor: colors.offWhite,
              borderColor: colors.transparent,
              borderTopRightRadius: noBorder,
            }
          : {
              borderColor: colors.borderColor,
              borderTopLeftRadius: noBorder,
            },
      ]}
    >
      <TranslatableText2 fontSize={fontSize} translation={lineTranslation}>
        {line}
      </TranslatableText2>
    </View>
  );
}

const styles = StyleSheet.create({
  balloon: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 8,
    borderWidth: 1,
  },
  fullWidth: {
    width: '100%',
  },
});
